// extracted by mini-css-extract-plugin
module.exports = {"SearchListWrapper":"Search_SearchListWrapper__8Erj2","SearchSectionTitle":"Search_SearchSectionTitle__uJe6S","RightGroup":"Search_RightGroup__dZSTP"};